import { ArrowRight } from 'lucide-react';

import { Block, blockAlignmentOptions } from '@/components/block';
import { BlockHeader } from '@/components/block/header';
import { Link } from '@/components/link';
import { LargeLinkBlockProps } from '@/types/block-types';
import { tv } from '@/utils/styles';

const LargeLinkBlock = ({
  id,
  heading,
  body,
  blockAlignment = 'left',
  blockLayout = 'horizontal',
  variant,
  noTopPadding = false,
  pages = [],
  className,
  ...props
}: LargeLinkBlockProps) => {
  const { base, block, grid, headingWrapper, linksWrapper, list, linkStyles } = styles({ blockLayout, variant });

  return (
    <div className={base()} id="large-link-block">
      <Block
        id={id}
        blockAlignment={blockAlignment}
        noTopPadding={noTopPadding}
        className={block({ className })}
        textColorVariant={variant}
        {...props}
      >
        <div
          style={{
            alignItems: blockAlignmentOptions[blockAlignment],
            textAlign: blockAlignment,
          }}
          className={grid()}
        >
          <div className={headingWrapper()}>
            <BlockHeader heading={heading} body={body} blockAlignment={blockAlignment} variant={variant} />
          </div>
          <div className={linksWrapper()}>
            <ul className={list()}>
              {pages &&
                pages.map((page) => (
                  <li key={page.slug}>
                    <Link href={`/${page.parent.slug}/${page.slug}`} className={linkStyles()}>
                      <span className="flex-1">{page.title}</span>
                      <ArrowRight className="size-5" />
                    </Link>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </Block>
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'text-text-primary',
    headingWrapper: 'mb-12',
    linksWrapper: 'max-w-5xl',
    block: null,
    grid: null,
    list: 'space-y-4',
    linkStyles:
      'flex w-full items-center overflow-hidden rounded-lg border border-grey-200 bg-white p-5 text-left text-baseLg font-semibold text-text-primary transition-all hover:border-grey-300 hover:text-lightBlue-700',
  },
  variants: {
    variant: {
      light: {
        base: 'bg-white',
      },
      grey: {
        base: 'bg-grey-50',
      },
    },
    blockLayout: {
      horizontal: {
        grid: 'grid grid-cols-[1fr] gap-x-12 lg:grid-cols-[1fr_2fr] [&>*:last-child]:pt-2',
        headingWrapper: 'lg:sticky lg:top-8 lg:h-fit',
      },
      vertical: {
        grid: 'flex flex-col',
      },
    },
  },
});

export { LargeLinkBlock };
